module.exports = __webpack_public_path__ + "static/media/SIGN.3845e78d.webp";